// search powered by Findify. See https://developers.findify.io/docs/merchant-js-api
import { emitShopifyEvent } from "./analytics.service";
/**
 * performs search using provided search term
 *
 */
export function search(searchTerm) {
    getSearch().push(findify => {
        findify.emit("search", searchTerm);
    });
}
/**
 * executes callback upon search. the callback parameter is the search term used.
 *
 */
export function onSearch(callback) {
    getSearch().push(findify => {
        findify.listen((event, props1, props2) => {
            if (event === 'search') {
                const searchTerm = typeof props1 === "string" ? props1 : props2;
                emitShopifyEvent("updated_search_submitted", { "search_term": searchTerm });
                callback(searchTerm);
            }
        });
    });
}
/**
 * executes callback upon autocomplete focus. the callback parameter is the widget's id.
 *
 */
export function onAutocompleteFocus(callback) {
    getSearch().push(findify => {
        findify.listen((event, props1) => {
            if (event === 'autocompleteFocus') {
                const widgetId = props1;
                callback(widgetId);
            }
        });
    });
}
/**
 * retrieves the search instance wrapper
 *
 */
function getSearch() {
    window.findifyCallbacks = window.findifyCallbacks || [];
    return window.findifyCallbacks;
}
